import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "media/avatars/150-2.jpg",
      alt: "image"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" })
  ])
], -1)
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}, "Rakib Hasan", -1)
const _hoisted_10 = { href: "#" }
const _hoisted_11 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_upgrade_plan"
}, "Upgrade to Pro", -1)
const _hoisted_13 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_14 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_19 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_20 = { class: "d-flex my-4" }
const _hoisted_21 = {
  href: "#",
  class: "btn btn-sm btn-light me-2",
  id: "kt_user_follow_button"
}
const _hoisted_22 = { class: "svg-icon svg-icon-3 d-none" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-sm btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_offer_a_deal"
}, "Hire Me", -1)
const _hoisted_24 = { class: "me-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_26 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_27 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_28 = { class: "d-flex flex-wrap" }
const _hoisted_29 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "svg-icon svg-icon-success me-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}, " 4500$ ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Earnings", -1)
const _hoisted_34 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}, " 75 ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Projects", -1)
const _hoisted_39 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = { class: "svg-icon svg-icon-3 svg-icon-success me-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}, " 60% ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Success Rate", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between w-100 mt-auto mb-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-6 text-gray-400" }, "Profile Compleation"),
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "50%")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "bg-success rounded h-5px",
      role: "progressbar",
      style: {"width":"50%"},
      "aria-valuenow": "50",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })
  ])
], -1)
const _hoisted_45 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_46 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("a", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ]),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" Developer ")
                  ]),
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" SF, Bay Area ")
                  ]),
                  _createElementVNode("a", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" max@kt.com ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                  ]),
                  _createTextVNode(" Follow ")
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Dropdown3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                      ]),
                      _hoisted_32
                    ]),
                    _hoisted_33
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr065.svg" })
                      ]),
                      _hoisted_37
                    ]),
                    _hoisted_38
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                      ]),
                      _hoisted_42
                    ]),
                    _hoisted_43
                  ])
                ])
              ]),
              _hoisted_44
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("ul", _hoisted_46, [
            _createElementVNode("li", _hoisted_47, [
              _createVNode(_component_router_link, {
                to: "/crafted/account/overview",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Overview ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: "/crafted/account/settings",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Settings ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}